import React, { useCallback, useContext, useEffect, useState, } from 'react';
import noop from 'lodash/noop';
import { TabsPosition, TabsType } from './enum';
import TabPane from './TabPane';
import TabGroup from './TabGroup';
import TabsWithContext from './TabsWithContext';
import ConfigContext from '../config-provider/ConfigContext';
const Tabs = function Tabs(props) {
    const { getConfig, getCustomizable } = useContext(ConfigContext);
    const { customizedCode, customizable = customizedCode ? getCustomizable('Tabs') : undefined, } = props;
    const $customizable = customizedCode ? customizable : false;
    const [loaded, setLoaded] = useState(!$customizable);
    const [customized, setCustomized] = useState();
    const loadCustomized = useCallback(async () => {
        if (customizedCode) {
            setLoaded(false);
            const customizedLoad = getConfig('customizedLoad');
            try {
                const remoteCustomized = await customizedLoad(customizedCode, 'Tabs');
                setCustomized({ panes: {}, ...remoteCustomized });
            }
            finally {
                setLoaded(true);
            }
        }
    }, [customizedCode]);
    useEffect(() => {
        if ($customizable) {
            loadCustomized();
        }
    }, [$customizable, loadCustomized]);
    return loaded ? (React.createElement(TabsWithContext, Object.assign({}, props, { customized: customized, setCustomized: setCustomized, customizable: $customizable }))) : null;
};
Tabs.displayName = 'Tabs';
Tabs.defaultProps = {
    defaultChangeable: true,
    tabCountHideable: true,
    tabTitleEditable: true,
    tabDraggable: true,
    hideAdd: false,
    showMore: false,
    destroyInactiveTabPane: false,
    onChange: noop,
    keyboard: true,
    tabPosition: TabsPosition.top,
    type: TabsType.line,
};
Tabs.TabPane = TabPane;
Tabs.TabGroup = TabGroup;
export default Tabs;
